// extracted by mini-css-extract-plugin
export default {"cardHeaderNumbers":"DIDSMSCardNumbers_cardHeaderNumbers__vBbPS","cardHeaderFrom":"DIDSMSCardNumbers_cardHeaderFrom__tjti-","cardHeaderTo":"DIDSMSCardNumbers_cardHeaderTo__w4EcL"};